exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sort-conf-form .el-table table tbody tr.filter-hidden{display:none}.sort-conf-form .el-table__body tr.disabled-field>td,.sort-conf-form .el-table__body tr.disabled-field>td input{font-style:italic;color:#aaa!important}.sort-conf-form .el-table__body tr.invalid-code>td .sort-code input,.sort-conf-form .el-table__body tr.invalid-label>td .sort-label input{border:1px dashed red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48ee79da","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/query/SortFieldConf.vue
// module id = 2176
// module chunks = 0